import * as React from "react";
import { BrowserRouter } from "react-router-dom";
import ErrorPage from "routes/public/ErrorPage/ErrorPage";

interface State {
  hasError: boolean;
}

class AppErrorBoundary extends React.Component<React.PropsWithChildren, State> {
  state: State = { hasError: false };

  static getDerivedStateFromError(): State {
    return { hasError: true };
  }

  componentDidCatch(error: Error, info: React.ErrorInfo) {
    console.error("Uncaught application error:", error, info);
  }

  render() {
    if (this.state.hasError) {
      return (
        <BrowserRouter>
          <div
            style={{
              display: "flex",
              justifyContent: "center",
              alignItems: "center",
              minHeight: "100vh",
              padding: 20,
            }}
          >
            <ErrorPage errorCode="app_error" />
          </div>
        </BrowserRouter>
      );
    }

    return this.props.children;
  }
}

export default AppErrorBoundary;
